import { getCurrentInstance } from '@vue/composition-api';

export default function useDynamicFields() {
  const vm = getCurrentInstance().proxy;

  const resolveFields = (field) => {
    switch (field.type_desc) {
      case 'DateTime Picker':
        return resolveDatePicker(field);
      case 'TextArea':
        return 'TextAreaField';
      default:
        return field.type_desc;
    }
  };

  const resolveDatePicker = (field) => {
    const relate = /([1-3])([1-2])/;
    const match = field.field_property.display_type.toString().match(relate);

    if (match) {
      field.field_property.display_type = match[1];
      field.field_property.half_size = true;
    }

    return 'DatePicker';
  };

  const resolveDateObject = (dateObject) => {
    const date = dateObject.date?.split('-') || '';
    const time = dateObject.time?.split(':') || '';

    let resolvedDate = null;

    if (date && time) {
      resolvedDate = `${date[2]}-${date[1]}-${date[0]} ${time[0]}:${time[1]}:00`;
    }

    if (date && !time) {
      resolvedDate = `${date[2]}-${date[1]}-${date[0]} 00:00:00`;
    }

    if (!date && time) {
      const today = new Date();

      resolvedDate = `${today.getFullYear()}-${today.toLocaleString('default', {
        month: '2-digit',
      })}-${today.toLocaleString('default', {
        day: '2-digit',
      })} ${time[0]}:${time[1]}:00`;
    }

    return resolvedDate;
  };

  const buildInformationPayload = (fieldList) =>
    new Promise((resolve, reject) => {
      const payload = {};

      try {
        fieldList.forEach((field) => {
          if (field.type_id == 11) {
            return (payload[field.api_key] = resolveDateObject(
              vm.$refs[field.key][0].fieldValue
            ));
          }

          return (payload[field.api_key] = vm.$refs[field.key][0].fieldValue);
        });

        resolve(payload);
      } catch (err) {
        reject(err);
      }
    });

  return { resolveFields, buildInformationPayload };
}
